// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bottom .el-form-item[data-v-972209d2] {\n  margin-bottom: 0;\n}\n.price[data-v-972209d2] {\n  font-size: 16px;\n  font-weight: bold;\n}", ""]);
// Exports
module.exports = exports;
